import { removeArticles } from "./string";

export function firstNameAndNextLetter(name) {
  if (!name) return "Invalid name";

  const partsName = removeArticles(name).split(" ");
  return `${partsName[0]} ${partsName[1] ? partsName[1][0] + "." : ""}`;
}
